import type React from 'react';
import { NAV_ITEMS, APP_NAME, type NavItemId } from '@shared/config/app';
import { useAppNavigationStore } from '@app/navigationStore';
import { UserIcon } from '@shared/ui';
import { WindowControls } from './WindowControls';
import { AccountMenu } from './AccountMenu';

function LogoMark() {
  return (
    <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent/15">
      <UserIcon className="h-5 w-5 text-accent" />
    </div>
  );
}

export function TopNav() {
  const activeTab = useAppNavigationStore((state) => state.activeTab);
  const setActiveTab = useAppNavigationStore((state) => state.setActiveTab);

  return (
    <header
      className="flex h-14 shrink-0 items-center justify-between border-b border-surface-border bg-surface-1 px-4"
      style={{ WebkitAppRegion: 'drag' } as React.CSSProperties}
    >
      <div className="flex items-center gap-3">
        <LogoMark />
        <span className="hidden text-[15px] font-semibold text-text-primary sm:block">{APP_NAME}</span>
      </div>

      <nav
        className="flex items-center gap-2 overflow-x-auto md:gap-8"
        style={{ WebkitAppRegion: 'no-drag' } as React.CSSProperties}
      >
        {NAV_ITEMS.map((item) => (
          <NavTab
            key={item.id}
            label={item.label}
            isActive={activeTab === item.id}
            onClick={() => setActiveTab(item.id)}
          />
        ))}
      </nav>

      <div
        className="flex items-center gap-2"
        style={{ WebkitAppRegion: 'no-drag' } as React.CSSProperties}
      >
        <AccountMenu />
        <div className="hidden md:flex">
          <WindowControls />
        </div>
      </div>
    </header>
  );
}

function NavTab({
  label,
  isActive,
  onClick,
}: {
  label: string;
  isActive: boolean;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`relative py-1 text-sm font-medium transition-colors ${
        isActive ? 'text-accent' : 'text-text-secondary hover:text-text-primary'
      }`}
    >
      {label}
      {isActive && <span className="absolute -bottom-[19px] left-0 right-0 h-0.5 bg-accent" />}
    </button>
  );
}

export type { NavItemId };
